<template>
  <div :class="$style.container" data-testid="property-overview-skeleton">
    <HeaderSkeleton />
    <PropertiesSkeleton />
  </div>
</template>

<script setup lang="ts">
import PropertiesSkeleton from '@/components/property-overview-page/MyProperties/Skeleton.vue';
import HeaderSkeleton from '@/components/property-overview-page/OverviewHeader/Skeleton.vue';
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.container {
  display: flex;
  flex-direction: column;
  gap: $space-50;
}
</style>
